<template lang="pug">
b-modal#updateNoticeModal.modal.fade(
  @close="showModal = false",
  centered,
  hide-footer="",
  tabindex="-1",
  aria-labelledby="updateNoticeModal",
  aria-hidden="true"
)
  h5.text-center.mb-4 Update Notice
  hr
  p We have updated the terms and conditions of use on 29,Nov.,2024. Please read it to keep on using your member right and interest.
    .custom-control.custom-checkbox.mr-sm-2.text-center.my-4
      input#customControlAutosizing2.custom-control-input(
        v-model="termsConditionsCheck",
        type="checkbox"
      )
      label.custom-control-label(for="customControlAutosizing2")
        | Accept &nbsp
        a(v-b-modal.modal-scrollable="", @click="showTermsCondition") Terms &amp; Conditions
        |
        | of Use.
  button.btn.btn-primary.btn-block(@click="onBtnClick") OK
</template>

<script>
export default {
  name: "DialogUpdateNotice",
  props: {
    termsConditionsCheck: Boolean,
  },
  data() {
    return {
      termsCondition: null,
    };
  },
  methods: {
    onBtnClick() {
      this.$emit("onDialogUpdateNoticeClick");
    },
    showTermsCondition() {
      this.$emit("showTermsCondition");
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep .modal-header {
  border: 0;
  padding-bottom: 0;
  justify-content: center;

  h5 {
    margin-bottom: 1.5rem;
  }
}
.custom-control-label {
  a {
    color: #082b6b !important;
    &:hover {
      color: #0056b3;
      text-decoration: underline;
    }
  }
}

@media only screen and (max-width: 767px) {
  ::v-deep h5 {
    font-weight: 300 !important;
  }
}
</style>
